import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "./baseQuery";
import { IInventory } from "../../types";

interface InventoryResponse {
  data: {
    inventory: IInventory[];
    totalCount: number;
  };
}

export const inventoryApi = createApi({
  reducerPath: "inventoryApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getInventoryList: builder.query<
      InventoryResponse,
      { page: number; search?: string }
    >({
      query: ({ page, search }) => {
        let url = `/inventory/list?pageNumber=${page}&pageSize=10`;
        if (search) url += `&search=${encodeURIComponent(search)}`;
        return {
          url,
          method: "GET",
        };
      },
    }),
    getInventoryItemDetails: builder.query<{ data: IInventory }, number>({
      query: (inventoryId) => ({
        url: `/inventory/item/details?inventoryId=${inventoryId}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetInventoryListQuery, useGetInventoryItemDetailsQuery } =
  inventoryApi;
